import { useDispatch, useSelector } from 'react-redux';
import {
  setTimeLeft as setTL,
  setTimeLeftString as setTLS,
  setEndDate as setED,
} from './timer.slice';

export default function useCountdownTimer() {
  const { timeLeft, timeLeftString, endDate } = useSelector(
    (state) => state.timer,
  );
  const dispatch = useDispatch();

  const setTimeLeft = (timeLeft) => {
    dispatch(setTL(Math.trunc(timeLeft / 1000)));
  };

  const setTimeLeftString = (timeLeftString) => {
    dispatch(setTLS(timeLeftString));
  };

  const setEndDate = (endTime) => {
    dispatch(setED(endTime));
  };

  return {
    timeLeft,
    timeLeftString,
    setTimeLeft,
    setTimeLeftString,
    setEndDate,
    endDate,
  };
}
